<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="title">{{$t('tips.szjymm')}}</div>
        </div>
        <div class="cotainer">
            <template v-if="Tversion == 3">
              <div class="tips">{{$t('sztkmm.dlmm')}}</div>
              <div class="temp1Inputb">
                <input class="text1" type="password" v-model="password" ref="input1" :placeholder="$t('sztkmm.dlmmts')">
                <template v-if="isPwd1">
                  <img v-if="!theme" v-show="password" src="@/assets/Log-In_close-eyes.png" class="texxt2" style="width: .6rem" @click="shpass1" />
                  <img v-else v-show="password" src="@/assets/theme/eyes.png" class="texxt2" style="width: .6rem" @click="shpass1" />
               </template>
               <template v-else>
                  <img v-if="!theme" v-show="password" src="@/assets/Log-In_eyes.png" class="texxt2" style="width: .6rem" @click="shpass1" />
                  <img v-else v-show="password" src="@/assets/theme/eyes2.png" class="texxt2" style="width: .6rem" @click="shpass1" />
               </template>
              </div>
            </template>
            <div class="tips">{{$t('tips.jymm')}}</div>
            <div class="temp1Inputb">
              <input class="text1" type="password" v-model="tpassword" oninput = "value=value.replace(/[^\d]/g,'')" ref="input2" :placeholder="$t('sztkmm.mmts')">
              <template v-if="isPwd2">
                <img v-if="!theme" v-show="tpassword" src="@/assets/Log-In_close-eyes.png" class="text2"
                  style="width: .6rem" @click="shpass2" />
                <img v-else v-show="tpassword" src="@/assets/theme/eyes.png" style="width: .6rem" class="text2"
                  @click="shpass2" />
              </template>
              <template v-else>
                <img v-if="!theme" v-show="tpassword" src="@/assets/Log-In_eyes.png" style="width: .6rem" class="text2"
                  @click="shpass2" />
                <img v-else v-show="tpassword" src="@/assets/theme/eyes2.png" style="width: .6rem" class="text2"
                  @click="shpass2" />
              </template>
            </div>
            <div class="tips">{{$t('sztkmm.qrmm')}}</div>
            <div class="temp1Inputb">
              <input class="text1" type="password" v-model="tpassword_again" oninput = "value=value.replace(/[^\d]/g,'')" ref="input3" :placeholder="$t('sztkmm.mmts')">
              <template v-if="isPwd3">
                <img v-if="!theme" v-show="tpassword_again" src="@/assets/Log-In_close-eyes.png" class="text2"
                  style="width: .6rem" @click="shpass3" />
                <img v-else v-show="tpassword_again" src="@/assets/theme/eyes.png" style="width: .6rem" class="text2"
                  @click="shpass3" />
              </template>
              <template v-else>
                <img v-if="!theme" v-show="tpassword_again" src="@/assets/Log-In_eyes.png" class="text2"
                  style="width: .6rem" @click="shpass3" />
                <img v-else v-show="tpassword_again" src="@/assets/theme/eyes2.png" style="width: .6rem" class="text2"
                  @click="shpass3" />
              </template>
            </div>
            <button class="btn-login btn-bg buttbg" @click="sure">{{$t('sztkmm.qr')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'setWithdrawPwd',
    data () {
        return {
          theme: false,
          token: '',
          password: '',
          tpassword: '',
          tpassword_again: '',
          isPwd1: true,
          isPwd2: true,
          isPwd3: true
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
      shpass1() {
        if(this.isPwd1){
          this.isPwd1 = false;
          this.$refs.input1.type = "text";
        }else{
          this.isPwd1 = true;
          this.$refs.input1.type = "password";
        }
      },
      shpass2() {
        if(this.isPwd2){
          this.isPwd2 = false;
          this.$refs.input2.type = "text";
        }else{
          this.isPwd2 = true;
          this.$refs.input2.type = "password";
        }
      },
      shpass3() {
        if(this.isPwd3){
          this.isPwd3 = false;
          this.$refs.input3.type = "text";
        }else{
          this.isPwd3 = true;
          this.$refs.input3.type = "password";
        }
      },
       goBack(){
           this.$router.go(-1);
       },
       sure(){
           var reg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+){6,12}$/;
            var data = {
                tpassword : this.tpassword,
                tpassword_again : this.tpassword_again
            }
            if(this.Tversion == 3){
              if(this.password == '' || this.password == null){
                  this.$toast.center(this.$t('sztkmm.dlmmts'));
                  return false;
              }
              data.password = this.password;
            }
            if(data.tpassword == '' || data.tpassword == null){
                this.$toast.center(this.$t('sztkmm.mmts'));
                return false;
            }else if(!reg.test(data.tpassword)){
                this.$toast.center(this.$t('sztkmm.mmts'));
                return false;
            }
            if(data.tpassword != data.tpassword_again){
                this.$toast.center(this.$t('sztkmm.mmts'));
                return false;
            }
            this.$ajax.post('/web/updateTpassword',data).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    this.$toast.center(resData.message);
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 1000)
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
       }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 2.4rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .tips{
        padding-bottom: 0.26rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .32rem 0;
        border-bottom: .01rem solid #ececec;
    }
    .cotainer .input-pwd{
        margin-top: .76rem;
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42rem;
    }
    .cotainer .input-box .code{
        color: #588bf8;
        font-size: .48rem;
    }
    .cotainer .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 0 1.2rem;
        font-size: .4rem;
    }
    .cotainer .btn-login{
        display: block;
        width: 100%;
        margin-top: 1.7rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/setWithdrawPwd.vue